import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "@posthog/react";

// Sends one $pageview per client-side route change (automatic pageview is
// disabled in init, so this is the single pageview source). Harmless when
// PostHog is not configured.
export default function AnalyticsPageviews() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;
    if (!process.env.REACT_APP_POSTHOG_KEY?.trim()) return;
    posthog.capture("$pageview", {
      $current_url: window.location.href,
      $pathname: location.pathname,
      $search: location.search,
      $hash: location.hash,
    });
  }, [posthog, location.pathname, location.search, location.hash]);

  return null;
}
